import React from 'react';
import styled from 'styled-components';
import { FieldPanelHeader } from 'styles/v2/Styles.styled';

const VerticalSeparator = styled.div`
  position: absolute;
  top: 0;
  bottom: -10px;
  left: 50%;
  width: 30px;
  background-color: #f6f6f6;
  transform: translateX(-50%);
  z-index: 0;
`;

const TitleRow = styled.div`
  display: contents; /* allows it to fit naturally into the grid */

  span {
    font-weight: 600;
    font-size: 1rem;
    padding-bottom: 10px;
  }
`;

interface ComparePanelComponentProps {
  title?: string;
  children?: React.ReactNode;
}

const ComparePanelComponent: React.FC<ComparePanelComponentProps> = ({ title, children }) => {
  return (
    <ComparePanel>
      {title && (
        <>
          <FieldPanelHeader>{title}</FieldPanelHeader>
          <FieldPanelHeader>{title}</FieldPanelHeader>
        </>
      )}
      {children}
      <VerticalSeparator />
    </ComparePanel>
  );
};

export const CompareDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-top: 0;
  width: 100%;
  grid-auto-flow: dense;
  position: relative;
`;

export const ComparePanel = styled(CompareDiv)`
  column-gap: 90px;
  padding: 30px;
  background-color: ${(props) => props.theme.colors.primaryWhite};
  position: relative;
  border-radius: 4px;
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.04);
`;

export default ComparePanelComponent;
